package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager

import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ObjectKinds(
    val value:String,
    val title:String,
    val width:Int,
    val height:Int,
    val type:ObjectKindTypes,
    val shape:ShapeEnum?=null,
    val img:String ?=null,
    val widthShownForSelection: Int?=null,
    val heightShownForSelection: Int?=null,
){
    //--------Table------------------------------------------------

    TABLE_RECTANGLE(
        value = "table",
        title =LanguageManager.getCurrentStrings().squaredTable,
        width = 60,
        height = 60,
        type = ObjectKindTypes.TABLE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.tableSquare,
        widthShownForSelection = 100,
        heightShownForSelection = 100,
    ),
    TABLE_ROUND(
        value = "table",
        title =LanguageManager.getCurrentStrings().roundTable,
        width = 60,
        height = 60,
        type = ObjectKindTypes.TABLE,
        shape = ShapeEnum.ROUND,
        img = Res.PathIcon.tableRound,
        widthShownForSelection = 100,
        heightShownForSelection = 100,
    ),
    //------Structure------------------------------------------------------
    HORIZONTAL_WALL(
        value = "wall",
        title =LanguageManager.getCurrentStrings().horizontalWall,
        width = 60,
        height = 10,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.horizontalWall,
        widthShownForSelection = 70,
        heightShownForSelection = 10,
    ),
    VERTICAL_WALL(
        value = "wall",
        title =LanguageManager.getCurrentStrings().verticalWall,
        width = 10,
        height = 60,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.verticalWall,
        widthShownForSelection = 10,
        heightShownForSelection = 70,
    ),
    HORIZONTAL_WINDOW(
        value = "window",
        title =LanguageManager.getCurrentStrings().horizontalWindow,
        width = 60,
        height = 10,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.horizontalWindow,
        widthShownForSelection = 70,
        heightShownForSelection = 10,
    ),
    VERTICAL_WINDOW(
        value = "window",
        title =LanguageManager.getCurrentStrings().verticalWindow,
        width = 10,
        height = 60,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.verticalWindow,
        widthShownForSelection = 10,
        heightShownForSelection = 70,
    ),
    SQAURED_COLUMN(
        value = "column",
        title = LanguageManager.getCurrentStrings().squaredColumn,
        width = 25,
        height = 25,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.column_square,
        widthShownForSelection = 54,
        heightShownForSelection = 54,
    ),
    ROUNDED_COLUMN(
        value = "column",
        title = LanguageManager.getCurrentStrings().roundedColumn,
        width = 25,
        height = 25,
        type = ObjectKindTypes.STRUCTURE,
        shape = ShapeEnum.ROUND,
        img = Res.PathIcon.column_circle,
        widthShownForSelection = 54,
        heightShownForSelection = 54,
    ),

    SINGlE_LEFT_DOOR(
        value = "doorLeft",
        title = LanguageManager.getCurrentStrings().singleDoor,
        width = 35,
        height = 45,
        type = ObjectKindTypes.STRUCTURE,
        img = Res.PathIcon.singleLeftDoor,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 36,
        heightShownForSelection = 40,
    ),
    SINGlE_RIGHT_DOOR(
        value = "doorRight",
        title = LanguageManager.getCurrentStrings().singleDoor,
        width = 35,
        height = 45,
        type = ObjectKindTypes.STRUCTURE,
        img = Res.PathIcon.singleRightDoor,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 36,
        heightShownForSelection = 40,
    ),
    DOUBLE_DOOR(
        value = "doubleDoors",
        title = LanguageManager.getCurrentStrings().doubleDoors,
        width = 70,
        height = 45,
        type = ObjectKindTypes.STRUCTURE,
        img = Res.PathIcon.doubleDoors,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 70,
        heightShownForSelection = 40,
    ),

    //--------Furniture-----------------------------------
    CHAIR(
        value = "chair",
        title = LanguageManager.getCurrentStrings().chair,
        width = 40,
        height = 40,
        type = ObjectKindTypes.FURNITURE,
        img = Res.PathIcon.chair,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 20,
        heightShownForSelection = 20,
    ),
    BAR_CHAIR(
        value = "barChair",
        title = LanguageManager.getCurrentStrings().barStool,
        width = 40,
        height = 40,
        type = ObjectKindTypes.FURNITURE,
        img = Res.PathIcon.barStool,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 20,
        heightShownForSelection = 20,
    ),
    ARM_CHAIR(
        value = "sofa",
        title = LanguageManager.getCurrentStrings().armChair,
        width = 40,
        height = 40,
        type = ObjectKindTypes.FURNITURE,
        img = Res.PathIcon.armChair,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 34,
        heightShownForSelection = 30,
    ),
    SOFA(
        value = "sofa",
        title = LanguageManager.getCurrentStrings().twoSeaterSofa,
        width = 52,
        height = 40,
        type = ObjectKindTypes.FURNITURE,
        img = Res.PathIcon.sofa_1_2,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 68,
        heightShownForSelection = 30,
    ),
    SOFA_THREE_SEATER(
        value = "sofa",
        title = LanguageManager.getCurrentStrings().threeSeaterSofa,
        width = 120,
        height = 40,
        type = ObjectKindTypes.FURNITURE,
        img = Res.PathIcon.sofa_1_3,
        shape = ShapeEnum.RECTANGLE,
        widthShownForSelection = 90,
        heightShownForSelection = 30,
    ),
    BAR(
        value = "bar",
        title = LanguageManager.getCurrentStrings().cocktailBarTable,
        width = 40,
        height =40,
        type = ObjectKindTypes.FURNITURE,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.bar,
        widthShownForSelection = 86,
        heightShownForSelection = 34,
    ),

    //------------Interior Decoration-------------------------------------
    TREE(
        value = "tree",
        title = LanguageManager.getCurrentStrings().tree,
        width = 30,
        height = 30,
        type = ObjectKindTypes.INTERIOR_DECORATION,
        img = Res.PathIcon.plant1,
        shape = ShapeEnum.ROUND,
        widthShownForSelection = 35,
        heightShownForSelection = 35,
    ),
    BUSH(
        value = "bush",
        title = LanguageManager.getCurrentStrings().bush,
        width = 40,
        height = 40,
        type = ObjectKindTypes.INTERIOR_DECORATION,
        img = Res.PathIcon.plant2,
        shape = ShapeEnum.ROUND,
        widthShownForSelection = 35,
        heightShownForSelection = 35,
    ),
    PLANT(
        value = "plant",
        title = LanguageManager.getCurrentStrings().plant,
        width = 30,
        height = 30,
        type = ObjectKindTypes.INTERIOR_DECORATION,
        img = Res.PathIcon.plant3,
        shape = ShapeEnum.ROUND,
        widthShownForSelection = 35,
        heightShownForSelection = 35,
    ),
    //----------Indicator---------------------
    EXIT(
        value = "exit",
        title = LanguageManager.getCurrentStrings().exit,
        width = 40,
        height = 40,
        type = ObjectKindTypes.INDICATOR,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.exit,
        widthShownForSelection = 50,
        heightShownForSelection = 50,
    ),
    WC(
        value = "wc",
        title = LanguageManager.getCurrentStrings().wc,
        width = 40,
        height = 40,
        type = ObjectKindTypes.INDICATOR,
        shape = ShapeEnum.RECTANGLE,
        img = Res.PathIcon.wc,
        widthShownForSelection = 50,
        heightShownForSelection = 50,
    ),
}